<template>
  <Dialog ref="dialog"
          width="60%"
          icon="fas fa-map"
          :show-confirm="true"
          @confirm="sendPlanning"
          title="Resumen de planificación">
    <div class="more-info">
      <el-row>
        <el-col :span=10>
          <p class="title">FECHA Y HORARIO</p>
          <p class="content">El {{formatDate(this.extraData.time_init)}} de
            {{formatHours(this.extraData.time_init)}} a
            {{formatHours(this.extraData.time_finish)}}</p>
        </el-col>
        <el-col :span=8>
          <p class="title">CT / CTT</p>
          <p class="content">
            {{this.extraData.ct.name}} - {{this.extraData.ct.id}}
            {{infoCD(this.extraData.ct.bu, this.extraData.ct.facility)}}
          </p>
        </el-col>
        <el-col :span=6>
          <p class="title">TIPO DE VIAJE</p>
          <p class="content">{{this.extraData.travel_type.name}}</p>
        </el-col>
      </el-row>
      <p class="title">SECTORES</p>
      <p class="socsTitle">subordenes</p>
      <div v-for="(sector, index) in this.sectors"
           :key="index"
           class="sectors">
        <div class="sector">
          <p class="subtitle">{{sector.name}}</p>
          <p class="content">
            <span>TAMAÑOS:</span>
            {{formatList(sector.packageTypes.map(l => l.type))}}.
          </p>
          <p class="content">
            <span>EMPRESA:</span>
            {{sector.enterprise.name}}.
          </p>
          <p class="content">
            <span>PATENTES:</span>
            {{countList(sector.vehicles)}}.
          </p>
          <p class="content">
            <span>REGIÓN:</span>
            {{ sector.region.name }}.
          </p>
          <p class="content">
            <span>LOCALIDADES:</span>
            {{formatList(sector.localities.map(l => l.name))}}.
          </p>
        </div>
        <div class="socCount">
          <p>{{sector.suborders.length}}</p>
        </div>
      </div>
      <div class="total">
        <div class="name"><p>total:</p></div>
        <div class="totalCount"><p>{{totalSocs}}</p></div>
      </div>
    </div>
    <div class="message" v-show="titleNotIncluded">
      <div class="stopwatch-animate">
      <span class="fa-stack fa-3x">
        <i :class="spin"/>
        <i class="fas fa-circle-notch fa-stack-2x fa-rotate-90" v-show="countDown === 0"/>
        <i class="fas fa-exclamation fa-stack-1x" v-show="countDown === 0"/>
      </span>
        <span class="counter" v-show="countDown > 0">{{countDown}}</span>
      </div>
      <div class="text-dialog">
        <p>{{titleNotIncluded}}</p>
        <p class="content">Si aún asi desea planificar el resto de las subordenes
          espere el contador.</p>
      </div>
    </div>
  </Dialog>
</template>

<script>
import moment from 'moment';
import Dialog from '../../base/Dialog.vue';

export default {
  name: 'Summary',
  components: {
    Dialog,
  },
  data() {
    return {
      timer: null,
      countDown: 0,
      extraData: {
        ct: '',
        travel_type: '',
      },
      sectors: {},
      totalSocs: 0,
      titleNotIncluded: null,
    };
  },
  methods: {
    showDialog(countNotIncluded, extraData, sectors) {
      this.extraData = extraData;
      this.sectors = sectors;
      this.countSocs(sectors);
      if (countNotIncluded > 0) {
        this.$refs.dialog.loading(true);
        this.titleNotIncluded = this.getTitle(countNotIncluded);
        this.countDown = 10;
        this.countDownTimer();
      }
      this.$refs.dialog.visible(true);
    },
    countSocs(sectors) {
      this.totalSocs = sectors.reduce((acum, el) => acum + el.suborders.length, 0);
    },
    getTitle(count) {
      return count === 1 ? 'HAY UNA SUBORDEN SIN SECTOR' : `HAY ${count} SUBORDENES SIN SECTOR`;
    },
    sendPlanning() {
      this.$emit('sendPlanning');
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$refs.dialog.loading(false);
      }
    },
    closeDialog() {
      this.$refs.dialog.visible(false);
    },
    cleanDialog() {
      clearTimeout(this.timer);
      this.$refs.dialog.loading(false);
      Object.assign(this, {
        timer: null,
        countDown: 0,
        extraData: {
          ct: '',
          travel_type: '',
        },
        sectors: {},
        titleNotIncluded: null,
        totalSocs: 0,
      });
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatHours(date) {
      return moment(date).format('LT');
    },
    formatList(list) {
      return list !== null ? list.join(', ') : 'Ninguna registrada';
    },
    countList(list) {
      return list !== null ? list.length : 0;
    },
    infoCD(bu, facility) {
      return bu && facility ? `(${bu}, ${facility})` : '';
    },
  },
  computed: {
    spin() {
      return this.countDown > 0
        ? 'fas fa-circle-notch fa-stack-3x fa-spin' : 'fas fa-circle-notch fa-stack-3x';
    },
  },
};
</script>

<style lang="scss" scoped>
  .more-info {
    font-size: 12px;
    text-align: left;
    margin: 0 0 20px 0;
    .title {
      font-weight: 600;
      color: $fb-green;
      margin: 12px 0 2px 0;
      text-transform: uppercase;
    }
    .socsTitle {
      text-align: right;
      margin: -10px 5px 3px 0;
    }
    .subtitle, .content {
      color: $fb-grey-light-30;
      margin: 0 0 5px 0;
      .soc-red-status {
        color: #ff8585;
        margin-left: 6px;
      }
    }
    .content {
      span { font-weight: 400; }
      font-weight: 300;
    }
    .sectors {
      display: flex;
      margin-bottom: 2px;
      .sector {
        width: calc(100% - 70px);
        float: left;
        .subtitle {
          margin-top: 10px;
          font-weight: 800;
        }
        .content { margin-right: 5px; }
      }
      .socCount {
        width: 70px;
        float: right;
        text-align: center;
        background-color: #efefef;
      }
    }
    .total {
      display: flex;
      .name {
        width: calc(100% - 70px);
        text-align: right;
        float: left;
      }
      .totalCount {
        width: 70px;
        float: right;
        color: white;
        background-color: #888888;
        text-align: center;
      }
      .name p, .totalCount p { margin: 4px; }
    }
  }
  .message {
    border: 1px solid #e6e6e6;
    display: flex;
    padding: 15px 10px;
    .stopwatch-animate {
      width: 60px;
      float: left;
      .fa-stack {
        margin-top: -2px;
        width: 41px;
        height: 38px;
        line-height: 0;
        .fa-circle-notch {
          color: #ffe000;
          font-size: 40px;
        }
        .fa-exclamation {
          top: 22px;
          font-size: 20px;
        }
      }
      .counter {
        width: 24px;
        font-size: 19px;
        position: absolute;
        text-align: center;
        margin: 5.5px 0 0 -33px;
      }
    }
    .text-dialog {
      float: left;
      text-align: left;
      width: calc(100% - 60px);
      p { margin: 0 0 0 11px };
      .content { font-weight: 300; }
    }
  }
</style>
